import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { formatCurrency } from "@nusrif/utils";
import config from "@nusrif/config";
interface CheckoutButtonProps {
  total: number;
  itemCount: number;
  onCheckout: () => void;
  disabled?: boolean;
}
export const CheckoutButton = ({
  total,
  itemCount,
  onCheckout,
  disabled = false,
}: CheckoutButtonProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-5 py-4 z-50">
      <div className="space-y-4">
        {/* Total Amount Display */}
        <div className="flex items-center justify-between">
          <span className="text-lg font-medium text-black">
            Total ({itemCount} item{itemCount !== 1 ? "s" : ""})
          </span>
          <span className="text-xl font-bold text-black">
            {formatCurrency(total, config.region.currencyCode)}
          </span>
        </div>
        {/* Checkout Button */}
        <Button
          onClick={onCheckout}
          disabled={disabled || itemCount === 0}
          className="w-full h-14 text-lg font-semibold rounded-full disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          Proceed to Checkout
          <ArrowRight className="w-5 h-5" />
        </Button>
      </div>
    </div>
  );
};
